var poll_header_default = {
  "title": "GivsD",
  "image": "_7UUiN",
  "webview": "LWWbR"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
